import { Component, Input, OnInit, OnChanges } from '@angular/core';

import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';

import { HTTPService, HelperService, DataService, CalculationService, FormatService } from 'app/services';
import { config, messages, tireTypeSuggestions } from 'app/constants';
import { UpdateCannedServiceDialogComponent } from '../update-canned-service-dialog/update-canned-service-dialog.component';
import { DeleteCategoryDialogComponent } from '../delete-category-dialog/delete-category-dialog.component';
import { currency } from 'app/constants/currency.constants';

import { find, debounce, findIndex } from 'lodash';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';

@Component({
  selector: 'app-tire-add',
  templateUrl: './tire-add.component.html',
  styleUrls: ['./tire-add.component.scss'],
})
export class TireAddComponent implements OnInit, OnChanges {
  @Input() brands: any[] = [];
  @Input() suppliers: any[] = [];
  @Input() locations: any[] = [];
  @Input() qboItemRefs: any[] = [];
  @Input() pricings: any[] = [];
  @Input() pricingRules: any[] = [];
  @Input() isLoading: boolean = false; // don't set this key inside this component
  @Input() data: any = {};
  @Input() item: any = {};
  @Input() stock: any = {};
  @Input() tireId: string = '';
  @Input() isLocal: boolean = true;
  @Input() isQboConnected: boolean = false;
  @Input() isOpenFromPO: boolean = false;
  @Input() isOpenFromMO: boolean = false;
  @Input() orderId: string = '';
  @Input() isTaxable: boolean = false;
  @Input() isInventoryEnabled: boolean = false;
  @Input() poDetails: any = {};
  @Input() orderServiceItemIndex: number = -1;
  @Input() orderServiceId: string = '';
  @Input() openFrom: string = '';
  @Input() serviceItem: any = {};
  @Input() averageCost: number = 0;
  @Input() latestPoCost: number = 0;
  @Input() defaultTaxable: boolean = false;
  @Input() isAutoLeapItem: boolean = false;
  @Input() isPartsTechItem: boolean = false;
  @Input() itemResults: any[] = [[]];
  @Input() isSearching: boolean = false;
  @Input() isOpenFromRO: boolean = false;
  @Input() isFeeAssociationEnabled: boolean = false;
  @Input() isCommissionPlanEnabled: boolean = false;
  @Input() isGlobalCategoryEnabled: boolean = false;
  @Input() isMarkAsInventoryEnabled: boolean = false;
  @Input() categories: any[] = [];
  @Input() categoryType: string = '';
  @Input() isOnlineInvOrderEnabled: boolean = false;
  @Input() isPricingMatricesManagement: boolean = false;
  @Input() isPricingManagementEnable: boolean = false;
  @Input() isNewItemCategoriesEnable: boolean = false;
  @Input() isAttributeBasedPricingEnable: boolean = false;
  @Input() isSalesCodeEnabled: boolean = false;
  @Input() isFinalizedRo: boolean = false;
  @Input() isOpenFromST: boolean = false;
  @Input() isQTQAddOnEnable: boolean = false;
  @Input() isPassThroughTaxEnable: boolean = false;
  @Input() isTireConnectConnected: boolean = false;
  @Input() canEditClassifications: boolean = false;

  selectedTab: number = 0;
  hazmatFeeObject: any = {};
  defaultSizeObject = {
    size: '',
    code: '',
    cost: '',
    count: 4, // adding default quantity against ticket ALP-17370
    pricingMatrix: null,
    price: '',
    isTaxable: true,
    status: true,
    displayDescOnOrder: true,
    displayHoursOnOrder: true,
    commissionable: true,
    hazmatFeeArray: [{}],
  };
  tire: any = {
    brand: null,
    model: '',
    vendor: null,
    seasonality: '',
    stocked: '',
    sizes: [],
    errors: [],
    category: { name: '' },
    locationQboItemRefId: {},
    isChangeInPriceMatrix: false,
    whichPricingMatrixUsed: '',
  };
  usd: string = currency.USD;
  defaultActiveState: boolean = true;
  tagsSuggestion: any[] = [];
  vendorsSuggestion: any[] = [];
  isProcessing: boolean = false;
  errors: any = {};
  defaultQboItemRefs: any[] = [];
  checkUniqueTitle = debounce(this._checkUniqueTitle, 600);
  checkUniqueCategory = debounce(this._checkUniqueCategory, 600);
  isCannedServiceFieldsUpdatetired: boolean = false;
  updateGenericItem: boolean = false;
  focus: any = {};
  // used to maintain state changes for each component
  initalInputStates = <any>{};
  updatedInputStates = <any>{};
  categoryResults: any[] = [];
  config: any = config;
  categoryName: any = '';
  isShowError: boolean = false;
  categorId: any = '';
  pricingMatrixList: any[] = [];
  noMatrix = [
    {
      name: 'No pricing rules',
    },
  ];
  isChangeInPriceMatrix: boolean = false;
  whichPricingMatrixUsed: any = '';
  isMultiLocationEnabled: boolean = false;
  isNewCategoriesEnabled: boolean = false;
  currentShopId: string = '';
  activityLogs: any[] = [];
  filterOptionModel = {
    itemHistory: false,
    purchaseHistory: false,
    sellingHistory: false,
    pricingHistory: false,
  };
  filterOption: any[] = [];
  isFilterLoading: boolean = false;
  selectedFilterOptionLength: number;
  categoriesSuggestions: any[] = [];
  subCategoriesSuggestions: any[] = [];
  subSubCategoriesSuggestions: any[] = [];
  tireTypeSuggestion: any[] = [];
  defaultTireTypeSuggestion = tireTypeSuggestions;
  isLockedRO = false;
  categoriesSuggestionsResults: any[] = [];
  subCategoriesSuggestionsResults: any[] = [];
  subSubCategoriesSuggestionsResults: any[] = [];
  showLoaderTireconnect: boolean = false;
  loader = {
    category: false,
    subCategory: false,
    subSubCategory: false,
  };
  classificationPrivilegeMsg: string = messages.classificationPrivilegeMsg;
  defaultSalesCode: any = {};
  isAutoAssign: boolean = false;

  constructor(
    private httpService: HTTPService,
    public helperService: HelperService,
    public formatService: FormatService,
    private dynamicDialogRef: DynamicDialogRef,
    private calculationService: CalculationService,
    private dataService: DataService,
    private dialogService: DialogService,
  ) { }

  ngOnInit() {
    this.tire.sizes.push(this.helperService.deepCopy(this.defaultSizeObject));
    this.tireTypeSuggestion = this.helperService.deepCopy(this.defaultTireTypeSuggestion);
    if (!this.tireId) {
      this.focus = { title: true };
    }

    if (this.isOpenFromRO) {
      this.isLockedRO = this.dataService.isLockedRO;
    }
    if (this.dataService.isNewItemCategoriesEnable) this.getAllCategories();
    // this.getTagList();
  }

  ngOnChanges(change: any) {
    const { isLoading } = change;

    if (isLoading) {
      if (isLoading.previousValue && !isLoading.currentValue) {
        if (!this.tireId) {
          this.defaultTaxable = this.isTaxable;
          this.defaultSizeObject.isTaxable = this.isTaxable;
          this.tire.sizes.forEach((tire: any) => {
            tire.isTaxable = this.isTaxable;

            if (this.isMarkAsInventoryEnabled) {
              tire.hasMarkedInventory = this.isOpenFromPO;
            }
          });
        }
        this.currentShopId = localStorage.getItem('currentShop') || this.helperService.getCurrentShopId();
        const { isMultiLocationEnabled } = this.helperService.getCompany();
        this.isMultiLocationEnabled = isMultiLocationEnabled;
        this.isNewCategoriesEnabled = this.dataService.isNewItemCategoriesEnable;
        this.isAttributeBasedPricingEnable = this.dataService.isAttributeBasedPricingEnable;
        this.tagsSuggestion = [...this.brands];
        this.setSuppliers(this.suppliers);
        this.setItemDetails(this.item);
        this.setCategories(this.categories);
        this.isProcessing = false;
      }
    }
  }

  openAssignSalesCodeDialog() {
    if (!this.canEditClassifications && !this.isOpenFromRO) {
      return;
    }
    const data = {
      item: this.tire,
      openFrom: 'old-tire-modal',
    };
    data.item.title = data.item?.name || '';
    this.dataService.sendData(this.dataService.typeDialog('open-sales-code-assign-modal', 'old-tire-modal', null, null, data));
  }

  setCategories(categories: any[]) {
    this.categoryResults = [...categories];
  }

  initializePricings() {
    if (!this.tireId) {
      this.setTireData();
    }
  }

  setSuppliers(suppliers: any[]) {
    this.vendorsSuggestion = [...suppliers];
  }

  setItemDetails(tire: any) {
    if (!this.tireId || !tire) {
      this.tire.sizes[0].commissionable = this.dataService.isCommissionTire;
      this.setTireData(true);
      return;
    }

    this.tire = {
      errors: [],
      model: tire.model,
      seasonality: tire.seasonality,
      salesCode: tire.salesCode,
      qboId: tire.qboId,
      locationQboItemRefId: tire.locationQboItemRefId || {},
      stocked: tire.stocked,
      shopDetails: tire.shopDetails,
      isChangeInPriceMatrix: tire.isChangeInPriceMatrix,
      whichPricingMatrixUsed: tire.whichPricingMatrixUsed,
      sizes: [
        {
          isTaxable: tire.isTaxable,
          status: tire.status,
          size: tire.size,
          stocked: tire.stocked,
          count: Number(tire.count),
          title: tire.title,
          titleFR: tire.titleFR,
          tireID: this.tireId,
          code: tire.code,
          commissionable: tire.commissionable,
          restockLevel: tire.restockLevel,
          maxQuantity: tire.maxQuantity,
          cost: Number(tire.cost),
          initialDefaultCost: Number(tire.cost),
          price: Number(tire.price),
          description: tire.description,
          descriptionFR: tire.descriptionFR,
          internalNotes: tire.internalNotes,
          notes: tire.notes,
          // totalCost: Number(tire.cost) * Number(tire.count),
          totalPrice: Number(tire.price) * Number(tire.count),
          displayDescOnOrder: tire.displayDescOnOrder,
          displayHoursOnOrder: tire.displayHoursOnOrder,
          pricingMatrix: {},
          tireExternalId: tire?.tireExternalId || tire?.code || '',
          fetValue: tire?.fetValue || 0,
          shopDetails: tire?.shopDetails || [],
          initialPrice: Number(tire.price),
          previousTitle: `${this.tire?.brand?.name || ''} ${this?.tire?.model || ''} ${tire.size || ''}`,
          previousTitleFR: `${this.tire?.brand?.titleFR || ''} ${this?.tire?.model || ''} ${tire.size || ''}`,
        },
      ],
    };

    if (tire.locations && tire.locations.length) {
      this.tire.sizes[0].location = tire.locations.pop();
    }

    if (!tire.costType) {
      this.tire.sizes[0].costType = tire.stocked ? 'avg' : 'cost';
      this.tire.sizes[0].cost = this.tire.sizes[0].costType === 'avg' ? this.averageCost : tire.fixedCost ? tire.fixedCost : tire.cost;
    } else {
      this.tire.sizes[0].costType = tire.costType;
      this.tire.sizes[0].cost = this.formatService.setDynamicCostAndPrice(tire, 'cost');
      this.tire.sizes[0].totalCost = Number(this.tire.sizes[0].cost) * Number(tire.count);
    }

    if (this.stock) {
      this.tire.sizes[0].qtyOnOrder = this.stock.countOnEstimate || 0;
      this.tire.sizes[0].qtyAvailable = this.stock.countAvailable || 0;
      this.tire.sizes[0].qtyOrdered = this.stock.countOrdered || 0;
      this.tire.sizes[0].qtyOnHand = this.stock.countInHand || 0;
    }

    if (this.isInventoryEnabled) {
      this.tire.hasMarkedInventory = tire.hasMarkedInventory;
    }

    if (this.tire?.stocked) {
      this.setStockedCostData(tire.costType, tire?.cost);
    }

    if (tire.associatedItems) {
      let getElementFromArray = tire.associatedItems.map((itm) => {
        if (itm?.itemId?.isPassThroughFet && itm?.itemId?.type === 'hazmatFee') {
          itm.itemId.price = tire?.fetValue || 0;
        }
        return itm.itemId;
      });

      if (tire.associatedItems.length > 0) {
        this.tire.sizes[0].hazmatFeeArray = getElementFromArray;
      } else {
        this.tire.sizes[0].hazmatFeeArray = [{}];
      }
    }

    this.defaultActiveState = tire.status;

    this.tire.brand =
      typeof tire?.brand === 'string'
        ? { name: tire?.brand }
        : {
          ...tire?.brand,
          name: tire?.brand?.displayName || tire?.brand?.name || tire?.brand?.brandName || '',
        };

    if (tire.category) {
      const { categoryId, name, categoryName } = tire.category;
      this.tire.category = {
        _id: categoryId || this.tire.category?._id,
        name: name ?? categoryName ?? this.tire?.category?.name,
        categoryName: name ?? categoryName,
      };
    }

    if (tire.supplier && tire.supplier.name) {
      this.tire.vendor = {
        _id: tire.supplier.supplierId,
        name: tire.supplier.name,
      };
    }

    if (tire.pricing && tire.pricing.pricingId) {
      this.tire.sizes[0]['pricingMatrix'] = {
        _id: tire.pricing.pricingId._id,
        name: tire.pricing.pricingId.name,
      };
    } else {
      if (this.isAttributeBasedPricingEnable) {
        this.tire.sizes[0]['pricingMatrix'] = this.noMatrix[0];
      }
    }

    if (this.isNewCategoriesEnabled) {
      this.tire.category = tire.category;
    }

    if (tire.tireType) {
      this.tire.tireType = tire.tireType;
    }

    if (this.isSalesCodeEnabled) {
      this.defaultSalesCode = this.helperService.deepCopy(tire?.salesCode);
    }

    this.checkShopLevelDetails();
    this.setSelectPricing();
    this.setItemRef();
    this.setTireData();
    this.tire.sizes[0].previousTitle = `${this.tire?.brand?.name || ''} ${tire?.model || ''} ${tire.size || ''}`;
    this.isProcessing = false;
    if (!this.tire.partsTechId) {
      this.tire.partsTechId = tire?.code || tire?.tireExternalId;
    }
  }

  checkShopLevelDetails() {
    const currentShopItemDetails = this.tire?.shopDetails?.find((s) => s.shopId === this.helperService.getCurrentShopId());
    if (currentShopItemDetails) {
      this.tire.sizes[0].price = currentShopItemDetails.price;
      this.tire.sizes[0].totalPrice = this.tire.sizes[0].count * this.tire.sizes[0].price;
      if (currentShopItemDetails?.pricing?.pricingId) {
        this.tire.sizes[0].pricingMatrix = {
          _id: currentShopItemDetails?.pricing?.pricingId,
          name: currentShopItemDetails?.pricing?.name,
        };
      }
    }
  }

  setStockedCostData(costType: string, tireCost: number) {
    if (costType) {
      if (costType === 'avg') {
        this.tire.sizes[0].cost = this.averageCost;
      } else if (costType === 'latestPo') {
        this.tire.sizes[0].cost = this.latestPoCost;
      } else if (costType === 'cost') {
        this.tire.sizes[0].cost = tireCost;
      }
    }
  }

  setTireData(isMappingNeeded: boolean = false) {
    if ((this.serviceItem && this.serviceItem.itemId) || (this.serviceItem && this.serviceItem.isPreFilledPartFields)) {
      if (this.serviceItem.model) {
        this.tire.model = this.serviceItem.model;
        this.isChangeInPriceMatrix = this.serviceItem.isChangeInPriceMatrix || false;
        this.whichPricingMatrixUsed = this.serviceItem.whichPricingMatrixUsed || false;
      }

      const size = {
        ...this.tire.sizes[0],
        title: this.serviceItem.title,
        titleFR: this.serviceItem.titleFR,
        description: this.serviceItem.description,
        descriptionFR: this.serviceItem.descriptionFR,
        internalNotes: this.serviceItem.internalNotes,
        notes: this.serviceItem.description,
        priceOnPO: this.serviceItem?.priceOnPO,
      };

      if (this.serviceItem.hasOwnProperty('seasonality')) {
        this.tire.seasonality = this.serviceItem.seasonality;
      } else if (this.serviceItem.hasOwnProperty('season')) {
        this.tire.seasonality = this.serviceItem.season;
      }

      if (this.serviceItem.hasOwnProperty('salesCode') && this.serviceItem.salesCode?.salesCodeId) {
        this.tire.salesCode = this.serviceItem.salesCode;
      }

      const { brand, category } = this.serviceItem;

      if (this.serviceItem.brand && this.serviceItem.brand.brandId) {
        this.tire.brand = {
          _id: this.serviceItem.brand.brandId,
          name: this.serviceItem.brand.name,
        };

        if (this.serviceItem.category?.categoryId) {
          if (this.isNewCategoriesEnabled) {
            this.tire.category = {
              ...this.serviceItem.category,
            };
          } else {
            this.tire.category = {
              ...this.tire.category,
              ...this.serviceItem.category,
            };
          }
        }
      } else if (this.serviceItem.category?.name) {
        const { categoryId, name } = this.serviceItem.category;
        this.tire.brand = { name };

        if (categoryId) this.tire.brand._id = categoryId;
      } else if (this.serviceItem?.brand) {
        let tireBrand = find(this.brands, { name: this.serviceItem.brand });
        if (!tireBrand) {
          this.tire.brand = { name: brand.brandName || brand.name || brand };

          if (category) {
            this.tire.category = {
              ...this.tire.category,
              name: category.categoryName || category.name || category,
              categoryName: category.categoryName || category.name || category,
            };
          }
        } else {
          this.tire.brand = tireBrand;
        }
      } else if (category) {
        this.tire.category = {
          ...this.tire.category,
          name: category.categoryName || category.name || category,
          categoryName: category.categoryName || category.name || category,
        };
      }

      if (this.serviceItem.supplier?.name) {
        const { supplierId, name } = this.serviceItem.supplier;
        this.tire.vendor = { name };

        if (supplierId) this.tire.vendor._id = supplierId;
      }

      if (this.serviceItem.hasOwnProperty('title')) {
        size.title = this.serviceItem.title || this.serviceItem.titleFR || '';
      }

      if (this.serviceItem.hasOwnProperty('titleFR')) {
        size.titleFR = this.serviceItem.titleFR || this.serviceItem.title || '';
      }

      if (this.serviceItem.hasOwnProperty('price')) {
        size.price = this.serviceItem.price;
        size.priceOnPO = size.price;
      }

      if (this.serviceItem.hasOwnProperty('cost')) {
        size.cost = this.serviceItem.cost;
        if (this.isOpenFromPO || this.isOpenFromST) {
          size.initialDefaultCost = this.serviceItem.cost;
        }
      }

      if (this.serviceItem.hasOwnProperty('isTaxable')) {
        size.isTaxable = this.serviceItem.isTaxable;
      }

      if (this.serviceItem.hasOwnProperty('commissionable')) {
        size.commissionable = this.serviceItem.commissionable;
      }

      if (this.serviceItem.hasOwnProperty('displayDescOnOrder')) {
        size.displayDescOnOrder = this.serviceItem.displayDescOnOrder;
      }

      if (this.serviceItem.hasOwnProperty('displayHoursOnOrder')) {
        size.displayHoursOnOrder = this.serviceItem.displayHoursOnOrder;
      }

      if (this.serviceItem.code) {
        size.code = this.serviceItem.code;
        if (this.openFrom === 'inventoryAdd') {
          if (!size.tireExternalId) {
            size.tireExternalId = this.serviceItem.code;
          }

          if (!this.tire?.partsTechId) {
            this.tire.partsTechId = this.serviceItem.code;
          }
        }
      }

      if (this.serviceItem.size) {
        size.size = this.serviceItem.size;
      }

      if (this.serviceItem.hasOwnProperty('count')) {
        size.count = this.serviceItem.count;
      }

      if (this.serviceItem.hasOwnProperty('tireExternalId')) {
        size.tireExternalId = this.serviceItem.tireExternalId;
        if (!this.tire?.partsTechId) {
          this.tire.partsTechId = this.serviceItem.tireExternalId;
        }
      } else if (this.serviceItem.hasOwnProperty('code')) {
        if (!this.tire?.partsTechId) {
          this.tire.partsTechId = this.serviceItem?.code;
        }
        if (!this.tire?.tireExternalId) {
          size.tireExternalId = this.serviceItem?.code;
        }
      }

      if (this.serviceItem.hasOwnProperty('fetValue')) {
        size.fetValue = this.serviceItem.fetValue;
        if (size?.hazmatFeeArray?.length) {
          const index = findIndex(size.hazmatFeeArray, { isPassThroughFet: true });
          if (index > -1) {
            size.hazmatFeeArray[index].price = this.serviceItem.fetValue;
            size.hazmatFeeArray[index].cost = this.serviceItem.fetValue;
          }
        }
      }

      if (this.serviceItem.hasOwnProperty('category')) {
        this.setServiceItemCategory();
      }

      if (this.serviceItem.hasOwnProperty('tireType')) {
        if (this.serviceItem.tireType) {
          const tireTypeObj = find(this.tireTypeSuggestion, { name: this.serviceItem?.tireType?.name || this.serviceItem.tireType });
          if (tireTypeObj) {
            this.tire.tireType = tireTypeObj;
          }
        }
      }

      if (this.serviceItem.pricing && this.serviceItem.pricing.pricingId) {
        if (size?.pricingMatrix?._id) {
          size.pricingMatrix.name = this.serviceItem.pricing.name;
          size.pricingMatrix.pricingId = this.serviceItem.pricing.pricingId;
        } else {
          size.pricingMatrix = this.serviceItem.pricing;
        }
      } else if (this.serviceItem.pricing) {
        size.pricingMatrix = this.serviceItem.pricing;
      }

      if (this.serviceItem.pricing && this.serviceItem.pricing.pricingId) {
        if (size?.pricingMatrix?._id && size.pricingMatrix?._id !== this.serviceItem.pricing.pricingId) {
          size.pricingMatrix = {
            _id: this.serviceItem.pricing.pricingId,
            name: this.serviceItem.pricing.name,
          };
        } else {
          if (size?.pricingMatrix?._id) {
            size.pricingMatrix.name = this.serviceItem.pricing.name;
            size.pricingMatrix.pricingId = this.serviceItem.pricing.pricingId;
          }
        }

        if (this.isAttributeBasedPricingEnable) {
          const result = this.pricingRules.find(element => element._id === this.serviceItem.pricing.pricingId);
          if (!size.pricingMatrix?.items?.length && result?.defaultMatrix?.items?.length) {
            size.pricingMatrix._id = result._id;
            size.pricingMatrix = { ...size.pricingMatrix, ...result.defaultMatrix };
            size.pricingMatrix.name = result.name;
          }

        }

        size.pricingMatrixOnPO = this.helperService.deepCopy(size.pricingMatrix);
      }

      if (this.serviceItem.hasOwnProperty('itemSource')) {
        this.isPartsTechItem = ['PartsTech', 'Nexpart'].includes(this.serviceItem.itemSource);
      }

      if (!isNaN(size.price) && !isNaN(size.cost) && !isNaN(size.count)) {
        size.totalPrice = this.calculationService.roundOff(Number(size.price * size.count));
        size.totalCost = this.calculationService.roundOff(Number(size.cost * size.count));
      }

      this.tire.sizes = [size];

      if (this.serviceItem.qboId) {
        this.tire.qboId = this.serviceItem.qboId;
        this.setItemRef();
      }

      if (isMappingNeeded) {
        this.setSelectPricing();
      }
    } else {
      if (this.isOpenFromPO && this.poDetails?.onlineItem && this.poDetails?.onlineItem?.orderType !== 'TireConnect') {
        this.setPartsTechTireInfo(this.poDetails?.onlineItem);
        this.tire.partsTechId = this.poDetails?.onlineItem?.code;

        try {
          const [brand, ...model] = this.poDetails?.onlineItem?.title?.split(' ');
          if (model) {
            this.tire.model = model.join(' ');
          }
          this.tire.vendor = this.poDetails?.onlineItem?.supplier;
          this.tire.supplier = this.poDetails?.onlineItem?.supplier;

          if (this.poDetails?.onlineItem.attributes && this.poDetails?.onlineItem?.attributes?.length) {
            this.tire.description = this.poDetails?.onlineItem.attributes.map(({ label, value }) => `${label}: ${value}`).join(', ');

            const season = find(this.poDetails?.onlineItem.attributes, { label: 'Category' });

            if (season) {
              if (new RegExp('all season', 'i').test(season.value)) this.tire.seasonality = 'all';
              else if (new RegExp('winter', 'i').test(season.value)) this.tire.seasonality = 'winter';
              else if (new RegExp('summer', 'i').test(season.value)) this.tire.seasonality = 'summer';
              else if (new RegExp('allWeather', 'i').test(season.value)) this.tire.seasonality = 'allWeather';
            }
          }
        } catch (err) {
          console.log(err);
        }
      } else if (this.isOpenFromPO && this.poDetails?.onlineItem && this.poDetails?.onlineItem?.orderType === 'TireConnect') {
        this.setPartsTechTireInfo(this.poDetails?.onlineItem);
        this.tire.partsTechId = this.poDetails?.onlineItem?.code;
        this.tire.model = this.poDetails?.onlineItem?.model;
        this.setPoDetailCategory();
        if (this.poDetails?.onlineItem?.tireType) {
          const tireTypeObj = find(this.tireTypeSuggestion, { name: this.poDetails?.onlineItem?.tireType });
          if (tireTypeObj) {
            this.tire.tireType = tireTypeObj;
          }
        }
        if (!this.tire.model) {
          const [model] = this.poDetails?.onlineItem?.title?.split(' ');
          if (model) {
            this.tire.model = model.join(' ');
          }
        }

        if (this.poDetails?.onlineItem?.brand) {
          const brand = find(this.brands, { name: this.poDetails?.onlineItem?.brand });
          if (brand) {
            this.tire.brand = brand;
          }
        }

        this.tire.vendor = this.poDetails?.onlineItem?.supplier;
        this.tire.supplier = this.poDetails?.onlineItem?.supplier;
        if (this.poDetails?.onlineItem?.season) {
          if (new RegExp('all season', 'i').test(this.poDetails?.onlineItem?.season)) this.tire.seasonality = 'all';
          else if (new RegExp('winter', 'i').test(this.poDetails?.onlineItem?.season)) this.tire.seasonality = 'winter';
          else if (new RegExp('summer', 'i').test(this.poDetails?.onlineItem?.season)) this.tire.seasonality = 'summer';
          else if (new RegExp('allWeather', 'i').test(this.poDetails?.onlineItem?.season)) this.tire.seasonality = 'allWeather';
        }
      }
    }
  }

  setServiceItemCategory() {
    if (this.serviceItem?.category) {
      const standardCategory = find(this.categoriesSuggestions, { categoryName: this.serviceItem?.category?.categoryName || this.serviceItem?.category });
      if (standardCategory) {
        this.tire.category = standardCategory;
      }
    }
  }

  setPoDetailCategory() {
    if (this.poDetails?.onlineItem?.category) {
      const standardCategory = find(this.categoriesSuggestions, { categoryName: this.poDetails?.onlineItem?.category });
      if (standardCategory) {
        this.tire.category = standardCategory;
      }
    }
  }

  setPartsTechTireInfo(tire: any) {
    this.tire = {
      brand:
        typeof tire?.brand === 'string'
          ? { name: tire?.brand }
          : {
            ...tire?.brand,
            name: tire?.brand?.displayName || tire?.brand?.name || tire?.brand?.brandName || '',
          },
      errors: [],
      model: tire?.model,
      seasonality: tire?.seasonality,
      qboId: tire?.qboId,
      stocked: tire?.stocked,
      sizes: [],
    };
    this.defaultSizeObject = {
      ...this.defaultSizeObject,
      size: tire?.tireSize || '',
    };
    this.tire.sizes.push(this.helperService.deepCopy(this.defaultSizeObject));
    this.tire.sizes.forEach((size: any) => {
      size.isTaxable = tire?.isTaxable;
      size.count = Number(tire?.quantity);
      size.title = '';
      // size.title = tire?.title;
      size.code = tire?.code;
      size.commissionable = this.dataService.isCommissionTire;
      size.cost = Number(tire?.cost);
      size.price = Number(tire?.price);
      size.description = tire?.description;
      size.totalCost = Number(tire?.cost) * Number(tire?.quantity);
      size.totalPrice = Number(tire?.price) * Number(tire?.quantity);
      size.hasMarkedInventory = this.isMarkAsInventoryEnabled ? this.isOpenFromPO : false;
      size.tireExternalId = tire?.code || '';
      size.initialPrice = Number(tire.price);
    });
  }

  /** Fetching items reference from QBO */
  fetchItemRefs() {
    this.httpService.getQBOItemRefs().then(
      (data: any) => {
        if (data.items && data.items.length) {
          this.qboItemRefs = data.items.filter(({ type }) => type === 'part');
          this.setItemRef();
          this.defaultQboItemRefs = this.helperService.deepCopy(this.qboItemRefs);
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  onCheckboxChange(event: Event, value) {
    this.selectedFilterOptionLength = 0;

    this.isFilterLoading = true;
    if (event) {
      this.filterOption.push(value);
    } else {
      this.filterOption = this.filterOption.filter((option) => option !== value);
    }

    // add with RO
    if (value === 'ci-purchase-history-po' && event) {
      this.filterOption.push('ci-purchase-history-ro');
    } else if (value === 'ci-purchase-history-po' && !event) {
      this.filterOption = this.filterOption.filter((option) => option !== 'ci-purchase-history-ro');
    }
    this.selectedFilterOptionLength = this.filterOption.length;
    if (this.filterOption.includes('ci-purchase-history-ro')) {
      this.selectedFilterOptionLength = this.selectedFilterOptionLength - 1;
    }

    this.getLogs();
  }

  getLogs() {
    // /appLogs/getByQuery
    const query = <any>{};
    if (this.filterOption?.length) {
      query.entityType = this.filterOption;
    }
    query.entityId = this.tireId;
    query.isItemLogs = true;
    this.httpService.getActivityLog(query).then(
      (data: any) => {
        console.log(data);
        if (data) {
          this.activityLogs = this.formatService.formateCatlogActivityLogs(data);
          this.isFilterLoading = false;
        }
        // if (data.items && data.items.length) {
        //   this.qboItemRefs = data.items.filter(({ type }) => type === 'part');
        //   this.setItemRef();
        //   this.defaultQboItemRefs = this.helperService.deepCopy(this.qboItemRefs);
        // }
      },
      (err) => {
        this.helperService.showToaster('error', err);
        this.isFilterLoading = false;
      },
    );
  }

  setSelectPricing() {
    this.pricingMatrixList = this.helperService.deepCopy(this.pricings);
    let matrixInfo = this.helperService.deepCopy(this.isAttributeBasedPricingEnable ? this.pricingRules : this.pricings);

    if (this.tire.sizes[0].pricingMatrix && matrixInfo && matrixInfo.length) {
      const [pricing] = matrixInfo.filter(({ _id }) => _id === this.tire.sizes[0].pricingMatrix._id);
      this.applyMatrix(pricing);
    }
  }

  applyMatrix(pricing) {
    if (pricing && pricing._id) {
      if (this.isAttributeBasedPricingEnable) {
        this.checkForOverrideCategory(pricing);
      } else this.tire.sizes[0].pricingMatrix = pricing;
    }
  }

  checkForOverrideCategory(pricing) {
    const categoryId = this.tire.category && this.tire.category._id;
    if (categoryId) {
      const overrideExist = pricing?.category?.find((c) => {
        return c._id === categoryId;
      });
      if (overrideExist) {
        this.getUpdatedMatrixDetails(pricing, overrideExist.matrix);
      } else {
        this.getUpdatedMatrixDetails(pricing, pricing.defaultMatrix);
      }
    } else {
      this.getUpdatedMatrixDetails(pricing, pricing.defaultMatrix);
    }
    if (!this.tire?.sizes[0]?.pricingMatrix?.name) {
      this.tire.sizes[0].pricingMatrix = this.noMatrix[0];
    }
  }

  getUpdatedMatrixDetails(rule, selectMatrix) {
    let matrixInfo = this.helperService.deepCopy(
      this.pricingMatrixList.find((m) => {
        return m._id === selectMatrix.id;
      }),
    );

    this.tire.sizes[0].pricingMatrix = rule;
    this.tire.sizes[0].pricingMatrix.items = matrixInfo?.items;
    this.tire.sizes[0].pricingMatrix.matrixName = matrixInfo?.name;
  }

  _checkUniqueTitle({ title = '', index }) {
    this.tire.sizes[index].title = title;
    this.httpService.isItemTitleUnique({ title: title.trim(), type: 'tire' }, this.tireId).then(
      (res) => {
        if (!this.tire.errors[index]) {
          this.tire.errors[index] = {};
        }

        if (!res) {
          this.tire.errors[index].title = 'Tire name must be unique';
          this.helperService.showToaster('error', 'Tire name must be unique');
        } else {
          this.tire.errors[index].title = '';
        }
      },
      (err) => {
        console.error(err);
      },
    );
  }

  _checkUniqueCategory() {
    this.httpService.isCategoryUnique({ name: this.categoryName.trim(), type: 'item' }, this.categorId).then(
      (res) => {
        if (!res) {
          this.isShowError = true;
        } else {
          this.isShowError = false;
        }
      },
      (err) => {
        console.error(err);
      },
    );
  }

  handleChangeCategory(name: string, value) {
    this.categoryName = value;
    this.checkUniqueCategory();
  }

  getCompanyDetails() {
    return new Promise((resolve, reject) => {
      const { companyId } = this.helperService.getCompany();

      this.httpService.getCompanyDetails(companyId).then(
        (company) => {
          if (company && company.shop) {
            this.isTaxable = company.shop.tire;
            this.defaultSizeObject.isTaxable = this.isTaxable;
          }

          resolve({});
        },
        (err) => {
          reject(err);
          this.helperService.showToaster('error', err);
        },
      );
    });
  }

  deleteCategoryDialog(e) {
    this.httpService
      .getAllCategories(e._id)
      .then((data: any) => {
        if (data.length) {
          const ref = this.dialogService.open(DeleteCategoryDialogComponent, {
            width: '1200px',
            styleClass: 'add-dialog overflow-initial delete-category-dialog',
            showHeader: false,
            data: {
              selectedCategory: e,
              categoryList: this.categoryResults,
              type: 'tire',
              isOnlyDelete: false,
              count: data.length,
            },
          });
          const onClose = ref.onClose.subscribe(({ isSuccess, data, selectedName }) => {
            if (isSuccess) {
              const { categoryId, name } = data.category;
              if (this.tire && this.tire.category?.name === name) {
                this.tire.category.name = selectedName;
              }
              this.categories.map((item, index) => {
                if (item._id === categoryId) this.categories.splice(index, 1);
              });
              this.categoryResults = [...this.categories];
            }
            onClose.unsubscribe();
          });
        } else if (data.length === 0) {
          const ref = this.dialogService.open(DeleteCategoryDialogComponent, {
            width: '1200px',
            styleClass: 'add-dialog overflow-initial delete-category-dialog',
            showHeader: false,
            data: {
              selectedCategory: e,
              categoryList: this.categoryResults,
              type: 'tire',
              isOnlyDelete: true,
              count: 0,
            },
          });
          const onClose = ref.onClose.subscribe(({ isSuccess, data, selectedName }) => {
            if (isSuccess) {
              const { categoryId, name } = data.category;
              if (this.tire && this.tire.category?.name === name) {
                this.tire.category.name = selectedName;
              }
              this.categories.map((item, index) => {
                if (item._id === categoryId) this.categories.splice(index, 1);
              });
              this.categoryResults = [...this.categories];
            }
            onClose.unsubscribe();
          });
        }
      })
      .catch((err) => this.helperService.showToaster('error', err));

    // const ref = this.dialogService.open(DeleteCategoryDialogComponent, {
    //   width: '1200px',
    //   styleClass: 'add-dialog overflow-initial delete-category-dialog',
    //   showHeader: false,
    //   data: {
    //     selectedCategory : e,
    //     categoryList: this.categoryResults,
    //     type:'tire'
    //   },
    // });
    // const onClose = ref.onClose.subscribe(({ isSuccess, data, selectedName }) => {
    //   if (isSuccess) {
    //     const { categoryId ,name} = data.category;
    //     if(this.tire && this.tire.category?.name === name) {this.tire.category.name = selectedName};
    //      this.categories.map( (item, index) => {
    //       if(item._id === categoryId) this.categories.splice(index,1);

    //     });
    //     this.categoryResults = [...this.categories];
    //   }
    //   onClose.unsubscribe();
    // });
  }

  /** Fetch list of all the tags */
  getTagList() {
    this.httpService.getTags(config.tags.tire).then(
      (categories: any[]) => {
        if (categories && categories.length) {
          this.brands = [...categories];
          this.tagsSuggestion = [...this.brands];
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  /** Fetch list of all the suppliers */
  getSupplierList() {
    this.httpService.getSuppliers().then(
      (vendors: any[]) => {
        if (vendors && vendors.length) {
          this.suppliers = [...vendors];
          this.vendorsSuggestion = [...this.suppliers];
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  /** Fetch list of all the pricings */
  getPricingList() {
    this.httpService.getPricings('part').then(
      (pricings: any[]) => {
        if (pricings && pricings.length) {
          this.pricings = pricings;
        }

        if (this.tireId) {
          this.setSelectPricing();
          this.setTireData();
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  handleTagSearch(query: string) {
    if (!query) {
      return;
    }

    this.tagsSuggestion = this.brands.filter(({ name }) => new RegExp(query, 'i').test(name));
  }

  handleVendorSearch(query: string) {
    if (!query) {
      return;
    }

    this.vendorsSuggestion = this.suppliers.filter(({ name }) => new RegExp(query, 'i').test(name));
  }

  handleTireTypeSearch(query: string) {
    if (!query) {
      return;
    }

    this.tireTypeSuggestion = this.defaultTireTypeSuggestion.filter(({ name }) => new RegExp(query, 'i').test(name));
  }

  onSearchItem(name: string, query: string) {
    if (name === 'category') {
      this.categoriesSuggestionsResults = this.categoriesSuggestions.filter(({ categoryName }) => categoryName && new RegExp(`${query}`, 'gi').test(categoryName));
    } else if (name === 'subCategory') {
      this.subCategoriesSuggestionsResults = this.subCategoriesSuggestions.filter(({ subCategoryName }) => subCategoryName && new RegExp(`${query}`, 'gi').test(subCategoryName));
    } else if (name === 'subSubCategory') {
      this.subSubCategoriesSuggestionsResults = this.subSubCategoriesSuggestions.filter(({ subSubCategoryName }) => subSubCategoryName && new RegExp(`${query}`, 'gi').test(subSubCategoryName));
    }
  }

  handleClear(type: string) {
    if (type === 'vendor') {
      this.vendorsSuggestion = [...this.suppliers];
    } else if (type === 'tireType') {
      this.tireTypeSuggestion = [...this.defaultTireTypeSuggestion];
    } else if (type === 'category') {
      this.categoriesSuggestionsResults = this.helperService.deepCopy(this.categoriesSuggestions);
    } else if (type === 'subCategory') {
      this.subCategoriesSuggestionsResults = this.helperService.deepCopy(this.subCategoriesSuggestions);
    } else if (type === 'subSubCategory') {
      this.subSubCategoriesSuggestionsResults = this.helperService.deepCopy(this.subSubCategoriesSuggestionsResults);
    } else {
      this.tagsSuggestion = [...this.brands];
    }
  }

  handleSelect(data: any, type: string) {
    switch (type) {
      case 'brand':
        this.tire.brand = data;
        this.errors.brand = '';
        this.focus.brand = false;
        // this.tire = this.helperService.deepCopy(this.tire);
        break;

      case 'vendor':
        this.tire.vendor = data;
        break;

      case 'category':
        this.tire.category = data;
        break;

      case 'tireType':
        this.tire.tireType = data;
        break;

      default:
        break;
    }

    this.setTireTitleCrtiteria(type);
  }

  handleChange(value: string, type: string) {
    // unselect seasonlity
    if (type === 'seasonality') {
      if (value === this.tire.seasonality) {
        value = '';
      }
    }
    if (type === 'stocked') {
      this.tire.sizes[0].stocked = value;
      this.tire.sizes[0].hasMarkedInventory = value;
    }

    this.tire[type] = value;
    this.errors[type] = '';
    this.setTireTitleCrtiteria(type);
  }

  handleBlur(type: string) {
    if (type === 'category' || type === 'model' || type === 'brand' || type === 'subCategory' || type === 'subSubCategory') {
      this.focus[type] = false;
    }
  }

  setTireTitleCrtiteria(type: string) {
    if (['brand', 'model', 'size'].includes(type)) {
      if (this.tire.sizes.length) {
        const title = `${this.tire?.brand?.name || ''} ${this?.tire?.model || ''} ${this.tire.sizes[0]?.size || ''}`;
        this.tire.sizes[0].title = title;
        this.tire.sizes[0].previousTitle = title;
        this.tire.sizes[0].titleFR = title;
        this.tire.sizes[0].previousTitleFR = title;

      }
    }
  }

  handleFocus(type: string) {
    this.focus[type] = true;
    this.errors[type] = '';

    if (type === 'subCategory' && !this.subCategoriesSuggestionsResults?.length) {
      if (this.tire.category?.categoryId) this.getSubCategories(this.tire.category);
    }

    if (type === 'subSubCategory' && !this.subSubCategoriesSuggestionsResults?.length) {
      if (this.tire.category?.categoryId && this.tire.category?.subCategoryId) this.getSubSubCategories(this.tire.category, this.tire.category);
    }
  }

  onFieldUpdateOnSize(event) {
    const { field, isUpdated, whichPricingMatrixUsed } = event;
    if (field === 'price' || field === 'cost' || field === 'count' || field === 'description' || field === 'isTaxable' || field === 'internalNotes') {
      this.updatedInputStates[field] = isUpdated;
    }
    if (field === 'pricingMatrix') {
      if (!this.isPricingManagementEnable || !this.isPricingMatricesManagement || this.isPricingMatricesManagement === undefined) {
        this.isChangeInPriceMatrix = true;
        this.updateGenericItem = false;
      }
    } else if (field === 'price') {
      this.tire.isPriceManuallyAdded = true;
      this.tire.whichPricingMatrixUsed = whichPricingMatrixUsed;
    }
  }

  handleAddSize() {
    this.itemResults = [[]];
    const size = this.helperService.deepCopy(this.defaultSizeObject);
    size.title = [this.tire?.brand?.name, this.tire.model].filter((str) => str).join(' ');
    size.commissionable = this.dataService.isCommissionTire;
    this.tire.sizes.push(size);
  }

  handleDeleteTireSize(index: number) {
    this.tire.sizes.splice(Number(index), 1);
    this.tire.errors[index] = {};
  }

  handleCloseModal() {
    this.dynamicDialogRef.close();
  }

  handleValidation() {
    let isValid = true;

    if (!this.tire.brand) {
      this.errors.brand = 'Brand required';
      isValid = false;
    }

    if (!this.tire.model) {
      this.errors.model = 'Vendor required';
      isValid = false;
    }

    const duplicatedTitles = this.tire.sizes.reduce((accumulator, currentItem, currentItemIndex, array) => {
      const index = array.findIndex((x) => x.title === currentItem.title);
      const duplicate = index !== currentItemIndex;

      if (duplicate) {
        return [...accumulator, currentItemIndex];
      } else return accumulator;
    }, []);

    this.tire.sizes.forEach(({ title, cost, count, price, size, maxQuantity, restockLevel, hasMarkedInventory, location, costType }: any, index: number) => {
      if (this.tire.errors[index] && this.tire.errors[index].title) {
        this.tire.errors[index] = {
          title: this.tire.errors[index].title,
        };
      } else {
        this.tire.errors[index] = {};
      }

      if (!title || !this.helperService.trimString(title)) {
        this.tire.errors[index].title = 'Tire name required';
        isValid = false;
      }

      if (duplicatedTitles && duplicatedTitles.length > 0 && duplicatedTitles.includes(index)) {
        this.tire.errors[index].title = 'Tire name must be unique';
        this.helperService.showToaster('error', 'Tire name must be unique');
        isValid = false;
      }

      if (!cost && costType === 'cost') {
        this.tire.errors[index].cost = 'Cost required';
        isValid = false;
      }

      // check if item is inventory
      if ((this.tire.stocked || hasMarkedInventory) && !location) {
        this.tire.errors[index].location = 'Location is required';
        this.helperService.showToaster('error', 'Location is required');
        isValid = false;
      }

      // check if item is inventory
      if ((this.tire.stocked || hasMarkedInventory) && Number(maxQuantity) < Number(restockLevel)) {
        this.tire.errors[index].restockLevel = 'Minimum quantity level can not be greater than the maximum quantity level';
        isValid = false;
      }

      if (!count) {
        this.tire.errors[index].count = 'Default qty required';
        isValid = false;
      }

      if (!price) {
        this.tire.errors[index].price = 'Price required';
        isValid = false;
      }

      if (!size) {
        this.tire.errors[index].size = 'Size required';
        isValid = false;
      }

      if (this.openFrom === 'inventoryAdd' && (!location || !location.locationId)) {
        // check if item is inventory
        this.tire.errors[index].location = 'Location is required';
        this.helperService.showToaster('error', 'Location is required');
        isValid = false;
      }
    });

    return isValid;
  }

  displaySalesCodeTitle() {
    return this.helperService.displaySalesCodeTitle(this.tire.salesCode, this.tire.category);
  }

  /** Set Item Ref */
  setItemRef() {
    if (this.tire && this.tire.qboId && this.qboItemRefs.length) {
      if (this.tire.sizes[0]) {
        this.tire.sizes[0].qboItemRef = find(this.qboItemRefs, {
          qboId: this.tire.qboId,
        });
      }
    }
    // if its an multiLocation tenant check that location level ref is saved then override the ref
    if (this.isMultiLocationEnabled) {
      if (this.tire && this.tire.locationQboItemRefId && this.tire.locationQboItemRefId[this.currentShopId] && this.qboItemRefs.length) {
        const refId = this.tire.locationQboItemRefId[this.currentShopId];
        this.tire.sizes[0].qboItemRef = find(this.qboItemRefs, {
          qboId: refId,
        });
      }
    }
  }

  getFeeArrayList(feeArray) {
    const hazamFeeList = [];
    feeArray.map((itm) => {
      if (itm && itm._id) {
        hazamFeeList.push({ itemId: itm._id });
      }
    });
    return hazamFeeList;
  }

  makeTirePayload(checkStockOnOrder: boolean = true, isOpenCreate: boolean = false) {
    const tires = [];
    this.tire.sizes.forEach((size: any) => {
      const tire: any = {
        isForceStockUpdate: !checkStockOnOrder,
        price: Number(size.price),
        code: size.code,
        title: size.title,
        titleFR: size.titleFR,
        model: this.tire.model,
        size: size.size,
        type: 'tire',
        count: size.count,
        commissionable: size.commissionable,
        description: size.description,
        descriptionFR: size.descriptionFR,
        internalNotes: size.internalNotes,
        notes: size.description,
        isTaxable: size.isTaxable,
        status: size.status,
        costType: size.costType,
        stocked: size.stocked,
        shopDetails: this.tire.shopDetails,
        hasMarkedInventory: size?.hasMarkedInventory || size?.stocked,
        seasonality: this.tire.seasonality,
        locationQboItemRefId: this.tire.locationQboItemRefId || {},
        displayDescOnOrder: size.displayDescOnOrder,
        displayHoursOnOrder: size.displayHoursOnOrder,
        associatedItems: this.getFeeArrayList(size.hazmatFeeArray),
        isChangeInPriceMatrix: this.isChangeInPriceMatrix,
        isPriceManuallyAdded: this.tire.isPriceManuallyAdded,
        whichPricingMatrixUsed: this.tire.whichPricingMatrixUsed,
      };

      if (tire.hasMarkedInventory || tire.stocked) {
        tire.restockLevel = size.restockLevel;
        tire.maxQuantity = size.maxQuantity;
      }

      if (this.isQTQAddOnEnable) {
        tire.tireExternalId = size?.tireExternalId || '';
      }

      if (this.isNewCategoriesEnabled && this.isSalesCodeEnabled) {
        if (this.tire.salesCode && this.tire.salesCode?.salesCodeId) tire.salesCode = this.tire.salesCode;
        else tire.salesCode = {};
      }

      //we only update cost when the cost type is cost - ALP-15794
      if (size.costType !== 'avg' && size.costType !== 'latestPo') {
        tire.cost = Number(size.cost);
      }

      if (this.isOpenFromPO) {
        tire.cost = Number(size.cost);
      }

      if (this.tire.brand) {
        tire.brand = this.tire.brand.name;
        tire.brandId = this.tire.brand._id;
      }

      const catergoryId = this.tire.category?._id || this.tire?.category?.categoryId;
      const categoryName = this.tire?.category?.name || this.tire?.category?.categoryName;
      if (categoryName || catergoryId) {
        tire.category = {
          categoryId: catergoryId || '',
          categoryName: categoryName || '',
        };
      }

      if (this.tire.vendor?._id || this.tire.vendor?.supplierId || this.tire.vendor?.name) {
        tire.supplier = {
          supplierId: this.tire.vendor._id || this.tire.vendor?.supplierId,
          name: this.tire.vendor.name,
        };
      }

      if (this.tire.tireType) {
        tire.tireType = {
          tireTypeId: this.tire?.tireType?.tireTypeId,
          name: this.tire?.tireType?.name,
          isCommercial: this.tire?.tireType?.isCommercial,
        };
      }

      if (size?.hasOwnProperty('fetValue')) {
        tire.fetValue = Number(size?.fetValue) || 0;
      }

      if (size.location && size.location.locationId) {
        tire.locations = [size.location];
      }

      if (size?.qboItemRef?.qboId) {
        tire.qboItemRefId = size.qboItemRef.qboId;
        tire.qboId = size.qboItemRef.qboId;
        if (this.isMultiLocationEnabled) {
          tire.locationQboItemRefId[this.currentShopId] = tire.qboId;
        }
      }

      if (size.pricingMatrix) {
        tire.pricing = {
          pricingId: size.pricingMatrix._id,
          name: size.pricingMatrix.name,
        };
      }
      this.checkShopLevelDetailsAdded(tire, isOpenCreate);

      if (this.isNewItemCategoriesEnable && this.isSalesCodeEnabled) {
        tire.isAutoAssign = this.isAutoAssign;
      }

      tires.push(tire);
    });

    return tires;
  }

  checkShopLevelDetailsAdded(tire, isOpenCreate) {
    if (!tire.shopDetails || tire.shopDetails.length === 0) {
      tire.shopDetails = [
        {
          shopId: this.helperService.getCurrentShopId(),
          pricing: {
            pricingId: tire?.pricing?.pricingId,
            name: tire?.pricing?.name,
          },
          price: tire.price,
          stocked: tire.stocked,
          maxQuantity: tire.maxQuantity || 0,
          restockLevel: tire.restockLevel || 0,
          whichPricingMatrixUsed: `${tire?.pricing?.name}:${tire?.pricing?.matrixName}:${tire?.price}`,
        },
      ];
    } else {
      const shopLevelDetails = findIndex(tire.shopDetails, {
        shopId: this.helperService.getCurrentShopId(),
      });
      if (shopLevelDetails === -1) {
        tire.shopDetails.push({
          shopId: this.helperService.getCurrentShopId(),
          pricing: {
            pricingId: tire?.pricing?.pricingId,
            name: tire?.pricing?.name,
          },
          price: tire.price,
          stocked: tire.stocked,
          maxQuantity: tire.maxQuantity || 0,
          restockLevel: tire.restockLevel || 0,
          whichPricingMatrixUsed: `${tire?.pricing?.name}:${tire?.pricing?.matrixName}:${tire?.price}`,
        });
      } else {
        (tire.shopDetails[shopLevelDetails].pricing = {
          pricingId: tire?.pricing?.pricingId,
          name: tire?.pricing?.name,
        }),
          (tire.shopDetails[shopLevelDetails].price = tire.price);
        tire.shopDetails[shopLevelDetails].stocked = tire.stocked;
        tire.shopDetails[shopLevelDetails].maxQuantity = tire.maxQuantity;
        tire.shopDetails[shopLevelDetails].restockLevel = tire.restockLevel;
        tire.shopDetails[shopLevelDetails].whichPricingMatrixUsed = `${tire?.pricing?.name}:${tire?.pricing?.matrixName}:${tire?.price}`;
      }
    }

    if (!isOpenCreate && !this.isOpenFromRO && !this.isOpenFromPO && !this.isOpenFromST) {
      delete tire.pricing;
      delete tire.price;
      delete tire.whichPricingMatrixUsed;
    }
    return tire;
  }

  handleSubmit(checkStockOnOrder: boolean = true) {
    if (!this.handleValidation() || this.isProcessing) {
      return;
    }

    if (this.tireId || (this.serviceItem && this.serviceItem.itemId)) {
      this.handleUpdateTire(this.makeTirePayload(checkStockOnOrder, false));
    } else {
      this.handleCreateTire(this.makeTirePayload(true, true));
    }
  }

  handleUpdateTire([tire]: any[]) {
    if (this.isProcessing) return;
    this.isProcessing = true;

    if (this.openFrom === 'inventoryAdd') {
      this.isProcessing = false;
      this.dynamicDialogRef.close();

      if (this.tireId) {
        tire._id = this.tireId;
      }

      this.dataService.sendData(this.dataService.typePassData('item-inventory-add', { ...tire }));
    } else if ((this.orderServiceId || this.isOpenFromPO) && !this.updateGenericItem && !this.isOpenFromMO) {
      this.handleCloseModal();
      this.isProcessing = false;

      if (this.isSalesCodeEnabled && tire.salesCode.salesCodeId && this.serviceItem?.salesCode?.salesCodeId !== tire.salesCode.salesCodeId) {
        this.logPXGaingSightCustomEvent(tire);
      }

      if (this.isOpenFromPO) {
        if (this.tireId) {
          tire._id = this.tireId;
        }

        this.dataService.sendData(
          this.dataService.typePassData('po-service-item', {
            ...tire,
            actionType: 'update',
            serviceId: this.orderServiceId,
            index: this.orderServiceItemIndex,
          }),
        );
      } else if (this.orderServiceId) {
        if (this.tireId) {
          tire._id = this.tireId;
        }
        if (tire.cost) {
          tire.cost = this.formatService.setDynamicCostAndPrice(tire, 'cost');
        }

        this.dataService.sendData(
          this.dataService.typePassData('ro-service-item', {
            ...tire,
            actionType: 'update',
            serviceId: this.orderServiceId,
            index: this.orderServiceItemIndex,
          }),
        );
      }
    } else {
      const item = this.helperService.deepCopy(tire);
      if (this.isSalesCodeEnabled && !this.canEditClassifications && (this.orderServiceId || this.isOpenFromPO)) {
        tire.salesCode = this.defaultSalesCode;
      }
      if(this.isOpenFromMO) {
        tire.isUpdateLocationOnly = true;
        tire.orderId = this.orderId;
      }
      this.httpService.updateItem({ ...tire, _id: this.tireId }).then(
        (res: any) => {
          this.handleCloseModal();
          if (res.cost) {
            res.cost = this.formatService.setDynamicCostAndPrice(res, 'cost');
          }

          if (this.isSalesCodeEnabled && !this.canEditClassifications && (this.orderServiceId || this.isOpenFromPO)) {
            res.salesCode = item?.salesCode;
          }

          if (this.isSalesCodeEnabled) {
            this.logPXGaingSightCustomEvent(res);
          }

          if(this.isOpenFromMO) this.dataService.sendData(this.dataService.typePassData('manual-order-update', {}));
          this.dataService.sendData(this.dataService.typePassData('tire-list', {}));
          this.helperService.showToaster('success', 'Tire updated');
          this.isProcessing = false;

          if (this.orderServiceId) {
            this.dataService.sendData(
              this.dataService.typePassData('ro-service-item', {
                ...res,
                actionType: 'update',
                serviceId: this.orderServiceId,
                index: this.orderServiceItemIndex,
              }),
            );
          }

          // open update canned service dialog
          if (Object.values(this.updatedInputStates).includes(true)) {
            if (this.updatedInputStates.cost && !this.updatedInputStates.description && !this.updatedInputStates.count && !this.updatedInputStates.isTaxable) {
              this.updateCannedService(res);
            } else {
              tire = {
                ...res,
                costRate: tire.cost,
              };
              this.openUpdateCannedServicesDialog({ ...tire, _id: this.tireId });
            }
          }
        },
        (err) => {
          if (err === 'exists_in_order') {
            const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
              width: '30%',
              styleClass: 'small-heading-dialog',
              showHeader: false,
              data: {
                styleClassHeading: 'font-14',
                title: 'Confirmation',
                message: 'This item is already used on an RO, Do you want to create this as a new inventory item',
                button: {
                  success: { title: 'Create new item' },
                  cancel: { title: 'Cancel' },
                },
              },
            });

            const onClose = ref.onClose.subscribe((close: any) => {
              if (close?.isSuccess) {
                // Creating new part
                const nPart = this.helperService.deepCopy(this.makeTirePayload(true, true));
                nPart[0].byPassUniqueTitleCheck = true;
                delete nPart[0]._id;
                this.isProcessing = false;
                this.handleCreateTire(nPart);

                // Updating old part
                this.tire.sizes[0].status = false;
                this.tire.sizes[0].name += ` - Non-inventory`;
                this.tire.sizes[0].hasMarkedInventory = false;
                this.isLoading = true;
                this.isProcessing = false;
                this.handleSubmit(false);
              } else {
                this.tire.sizes[0].isForceStockUpdate = true;
                this.isProcessing = false;
                this.handleSubmit(false);
              }

              onClose.unsubscribe();
            });
          } else {
            this.isProcessing = false;
            this.helperService.showToaster('error', err);
          }
        },
      );
    }
  }

  async updateCannedService(data) {
    const cannedServices = await this.httpService.getCannedServicesByItem(this.tireId);

    if (cannedServices.length === 0) {
      return;
    }
    const payload = <any>{
      services: cannedServices.map((c: any) => {
        return {
          _id: c._id,
          itemType: c.itemType,
        };
      }),
      itemId: this.tireId,
      isPassThroughTax: data.isPassThroughTax,
    };
    payload.cost = this.formatService.setDynamicCostAndPrice(data, 'cost');
    payload.price = this.formatService.setDynamicCostAndPrice(data, 'price');
    await this.httpService.updateCannedServicesByItem(payload);
  }

  /**
   * Get canned services for the provided item
   */
  async openUpdateCannedServicesDialog(data) {
    try {
      const cannedServices = await this.httpService.getCannedServicesByItem(data._id);

      if (cannedServices.length === 0) return;
      data.cost = this.formatService.setDynamicCostAndPrice(data, 'cost');
      data.price = this.formatService.setDynamicCostAndPrice(data, 'price');
      // open update canned service dialog
      this.dialogService.open(UpdateCannedServiceDialogComponent, {
        width: '50%',
        styleClass: 'add-dialog add-part update-canned overflow-initial',
        showHeader: false,
        data: {
          part: data,
          cannedServices,
          updatedFields: Object.keys(this.updatedInputStates).filter((key) => {
            try {
              return this.updatedInputStates[key];
            } catch (e) {
              return false;
            }
          }),
        },
      });
    } catch (error) {
      this.helperService.showToaster('error', error);
    }
  }

  onUpdateSupplier(data) {
    this.httpService.updateSupplier(data).then(
      (res: any) => {
        for (let i = 0; i < this.suppliers.length; i++) {
          if (this.suppliers[i]._id === res._id) {
            this.suppliers[i].name = data.name;
            break;
          }
        }

        for (let i = 0; i < this.vendorsSuggestion.length; i++) {
          if (this.vendorsSuggestion[i]._id === res._id) {
            this.vendorsSuggestion[i].name = data.name;
            break;
          }
        }

        if (this.tire.vendor && this.tire.vendor._id === res._id) {
          this.tire.vendor.name = data.name;
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  onUpdateItem({ name, color, _id }, type: string) {
    const tag = {
      _id,
      color: color,
      type,
      name: name.trim(),
    };

    this.httpService.updateTag(tag).then(
      (data) => {
        for (let i = 0; i < this.categories.length; i++) {
          if (this.categories[i]._id === _id) {
            this.categories[i].name = name;
            break;
          }
        }

        for (let i = 0; i < this.brands.length; i++) {
          if (this.brands[i]._id === _id) {
            this.brands[i].name = name;
            break;
          }
        }

        for (let i = 0; i < this.categoryResults.length; i++) {
          if (this.categoryResults[i]._id === _id) {
            this.categoryResults[i].name = name;
            break;
          }
        }

        for (let i = 0; i < this.tagsSuggestion.length; i++) {
          if (this.tagsSuggestion[i]._id === _id) {
            this.tagsSuggestion[i].name = name;
            break;
          }
        }

        if (this.tire.brand && this.tire.brand._id === _id) {
          this.tire.brand.name = name;
        }

        if (this.tire.category && this.tire.category._id === _id) {
          this.tire.category.name = name;
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  handleCreateTire(tires: any[]) {
    if (this.isProcessing) {
      return;
    }
    this.isProcessing = true;
    const item = this.helperService.deepCopy(tires);
    if (this.isOpenFromPO || (this.orderServiceId && tires.length)) {
      if (this.isSalesCodeEnabled && !this.canEditClassifications) {
        tires[0].salesCode = this.defaultSalesCode;
      }
    }
    this.httpService.createTires(tires).then(
      (res: any) => {
        this.handleCloseModal();
        this.dataService.sendData(this.dataService.typePassData('tire-list', {}));
        this.helperService.showToaster('success', 'Tire created');

        if (this.isOpenFromPO || this.orderServiceId) {
          if (this.isSalesCodeEnabled && !this.canEditClassifications) {
            res.salesCode = item?.salesCode;
          }
        }

        if (this.isSalesCodeEnabled) {
          this.logPXGaingSightCustomEvent(res);
        }

        if (this.isOpenFromPO) {
          if (res && res.length > 0) {
            res.forEach((item: any) => {
              item.actionType = 'create';
              if (!item.itemId) {
                item.itemId = item._id;
              }
            });
          }
          this.dataService.sendData(
            this.dataService.typePassData('po-service-item', {
              ...res,
              items: res,
              actionType: 'create',
              poDetails: this.poDetails,
              serviceId: this.orderServiceId,
              index: this.orderServiceItemIndex,
            }),
          );
        } else if (this.orderServiceId) {
          this.dataService.sendData(
            this.dataService.typePassData('ro-service-item', {
              items: res,
              serviceId: this.orderServiceId,
            }),
          );
        } else if (this.openFrom === 'cannedService') {
          this.dataService.sendData(this.dataService.typePassData('canned-service-item', { items: res, actionType: 'create' }));
        } else if (this.openFrom == 'inventoryAdd') {
          if (this.tire.location && this.tire.location.locationId) {
            res.locations = [{ ...this.tire.location }];
          }

          this.dataService.sendData(this.dataService.typePassData('item-inventory-add', { ...((res && res[0]) || {}) }));
        } else {
          this.dataService.sendData(this.dataService.typePassData('catalogue-item', { ...((res && res[0]) || {}), actionType: 'create' }));
        }

        this.isProcessing = false;
      },
      (err) => {
        this.isProcessing = false;
        this.helperService.showToaster('error', err);
      },
    );
  }

  handleCreateBrand(data: any) {
    data.type = config.tags.tire;

    if (!data.isForFurtureUse) {
      this.brands.push(data);
      this.tagsSuggestion.push(data);
    } else {
      this.httpService.createTag(data).then(
        (brand: any) => {
          if (brand) {
            this.helperService.showToaster('success', 'Brand created');
            this.brands.push(brand);
            this.tire.brand = brand;
            this.tagsSuggestion.push(brand);
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      );
    }
  }

  handleCreateSupplier(data: any) {
    if (!data.isForFurtureUse) {
      this.suppliers.push(data);
      this.vendorsSuggestion.push(data);
    } else {
      this.httpService.createSupplier(data).then(
        (supplier: any) => {
          if (supplier) {
            this.helperService.showToaster('success', 'Vendor created');
            this.suppliers.push(supplier);
            this.vendorsSuggestion.push(supplier);
          }
        },
        (err) => {
          this.helperService.showToaster('error', err.messages);
        },
      );
    }
  }

  handleCreateTireType(data: any) {
    // if (!data.isForFurtureUse) {
    //   this.suppliers.push(data);
    //   this.vendorsSuggestion.push(data);
    // } else {
    //   this.httpService.createSupplier(data).then(
    //     (supplier: any) => {
    //       if (supplier) {
    //         this.helperService.showToaster('success', 'Vendor created');
    //         this.suppliers.push(supplier);
    //         this.vendorsSuggestion.push(supplier);
    //       }
    //     },
    //     (err) => {
    //       this.helperService.showToaster('error', err.messages);
    //     }
    //   );
    // }
  }

  removeHazmatFee({ sizeIndex, feeIndex }) {
    if (this.isPassThroughTaxEnable) {
      const fee = this.tire.sizes[sizeIndex].hazmatFeeArray[feeIndex];
      const FETIndex: number = fee?.title?.toUpperCase()?.indexOf('FET');
      if (this.tire.sizes[sizeIndex].fetValue > 0 && FETIndex > -1) {
        const message: string = 'By deleting FET fee. FET would became $0.00. Are you sure you want to remove it';
        this.openConfirmationPrompt(feeIndex, sizeIndex, message);
        return;
      }
    }
    this.tire.sizes[sizeIndex].hazmatFeeArray.splice(feeIndex, 1);
  }

  addAnotherFee(sizeIndex) {
    this.tire.sizes[sizeIndex].hazmatFeeArray.push(this.helperService.deepCopy(this.hazmatFeeObject));
  }

  onROSelect({ event, sizeIndex, feeIndex }) {
    this.tire.sizes[sizeIndex].hazmatFeeArray[feeIndex] = event;
    this.itemResults.map((searchList, i) => {
      this.itemResults[i] = searchList.filter((itm) => itm._id !== event._id);
    });
  }

  getFETRatefromTireConnect(sizeIndex: number) {
    if (!this.tire?.sizes[sizeIndex]?.tireExternalId) {
      return;
    }
    const dataObj = {
      partNumbers: [this.tire.sizes[sizeIndex]?.tireExternalId],
      season: null,
      categories: [],
      suppliers: [],
      offers: [],
    };
    this.showLoaderTireconnect = true;
    this.httpService
      .getFETFromTireConnect(dataObj)
      .then(
        (res: any) => {
          if (res?.data?.tires?.length) {
            this.tire.sizes[sizeIndex].tireconnectFetValue = res?.data?.tires[0].fet || 0;
            this.tire.sizes[sizeIndex].tireconnectFetSource = res?.data?.tires[0]?.fet_source || '';
          } else {
            this.helperService.showToaster('error', res?.notice);
          }
        },
        (err: any) => {
          this.helperService.showToaster('error', err);
        },
      )
      .finally(() => {
        this.showLoaderTireconnect = false;
      });
  }

  openConfirmationPrompt(feeIndex: number, sizeIndex: number, message: string) {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        title: 'FET fee is associated',
        message: message,
        button: {
          success: { title: 'Confirm' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe((close: any) => {
      if (close?.isSuccess) {
        this.tire.sizes[sizeIndex].hazmatFeeArray.splice(feeIndex, 1);
        if (this.tire.sizes[sizeIndex]?.fetValue) {
          this.tire.sizes[sizeIndex].fetValue = 0;
        }
      }
      onClose.unsubscribe();
    });
  }

  getFetFee(sizeIndex: number) {
    const feeIndex = findIndex(this.tire.sizes[sizeIndex].hazmatFeeArray, (fee: any) => {
      if (fee?.title?.toUpperCase()?.indexOf('FET') > -1) {
        return true;
      } else {
        return false;
      }
    });
    if (feeIndex > -1) {
      if (!this.tire.sizes[sizeIndex].fetValue) {
        const message: string = 'Are you sure you want to disassociate it?.';
        this.openConfirmationPrompt(feeIndex, sizeIndex, message);
      } else {
        this.tire.sizes[sizeIndex].hazmatFeeArray[feeIndex].price = this.tire.sizes[sizeIndex].fetValue;
      }
      return;
    }

    if (!this.tire.sizes[sizeIndex].fetValue) {
      return;
    }

    this.httpService
      .getItems({
        limit: 1,
        type: 'hazmatFee',
        fetchFETFee: true,
      })
      .then(
        (res: any) => {
          if (res) {
            if (this.tire.sizes[sizeIndex].hazmatFeeArray.length === 0) {
              this.tire.sizes[sizeIndex].hazmatFeeArray.push(res);
            }
            this.onROSelect({ event: res, sizeIndex, feeIndex: this.tire.sizes[sizeIndex].hazmatFeeArray.length - 1 });
            const fetFeeIndex = this.tire.sizes[sizeIndex].hazmatFeeArray.length - 1;
            this.tire.sizes[sizeIndex].hazmatFeeArray[fetFeeIndex].price = this.tire.sizes[sizeIndex].fetValue;
          }
        },
        (err: any) => {
          this.helperService.showToaster('error', err);
        },
      );
  }

  searchSuggestion({ event, index, sizeIndex }) {
    this.isSearching = true;
    this.httpService
      .getItems({
        limit: 100,
        search: event.trim(),
        type: 'hazmatFee',
      })
      .then(
        (data: any) => {
          this.itemResults[index] = [];
          if (data.records) {
            if (this.tire.sizes[sizeIndex].hazmatFeeArray.length > 0) {
              this.itemResults[index] = data.records.filter(({ _id, title }) => !this.tire.sizes[sizeIndex].hazmatFeeArray.find((fee: any) => fee && fee._id === _id && fee.title === title));
            } else {
              this.itemResults[index] = data.records;
            }
          }
        },
        (err) => {
          this.isSearching = false;
          this.helperService.showToaster('error', err);
        },
      )
      .finally(() => {
        this.isSearching = false;
      });
  }

  showSuggestions(type?: string) {
    if (type === 'tags') {
      this.categoryResults = [...this.categories];
    }
    this.isShowError = false;
  }

  saveCategory({ name }) {
    this.createCategory({
      name,
      type: this.categoryType ? this.categoryType : config.tags.tire,
      color: '',
    });
  }

  createCategory(data: any) {
    this.httpService.createTag(data).then(
      (category: any) => {
        if (category) {
          this.helperService.showToaster('success', messages.categoryCreated);
          this.categories.push(category);
          this.tire.category = category;
          this.categoryResults = [...this.categories];
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  onClearSuggestion(type: string = '') {
    if (type === 'tags') {
      this.categoryResults = [...this.categories];
    }
  }

  searchSuggestionCategory(query: string, type?: string) {
    this.categoryResults = [];
    query = this.helperService.trimString(query);
    if (type === 'tags') {
      this.categoryResults = this.categories.filter(({ name }) => {
        if (name && new RegExp(`${query}`, 'gi').test(name)) {
          return true;
        } else {
          return false;
        }
      });
    }
  }

  categoryDropdownSelect(type: string, event: any) {
    const payload: any = { salesCode: event.salesCode };

    if (type === 'category' && event.categoryId) {
      delete this.tire?.category?.subCategoryId;
      delete this.tire?.category?.subCategoryName;
      delete this.tire?.category?.subSubCategoryId;
      delete this.tire?.category?.subSubCategoryName;
      this.getSubCategories(event);
      this.subCategoriesSuggestions = [];
      this.subCategoriesSuggestionsResults = [];
      this.subSubCategoriesSuggestions = [];
      this.subSubCategoriesSuggestionsResults = [];
      payload.category = event;
    }

    if (type === 'subCategory' && event.subCategoryId) {
      delete this.tire?.category?.subSubCategoryId;
      delete this.tire?.category?.subSubCategoryName;
      this.getSubSubCategories(this.tire.category, event);
      this.subSubCategoriesSuggestions = [];
      this.subSubCategoriesSuggestionsResults = [];
      payload.category = {
        categoryId: this.tire?.category?.categoryId,
        categoryName: this.tire?.category?.categoryName,
      };
      payload.subCategory = event;
    }

    if (type === 'subSubCategory' && event?.subSubCategoryId) {
      payload.category = {
        categoryId: this.tire?.category?.categoryId,
        categoryName: this.tire?.category?.categoryName,
      };
      payload.subCategory = {
        subCategoryId: this.tire?.category?.subCategoryId,
        subCategoryName: this.tire?.category?.subCategoryName,
      };
      payload.subSubCategory = event;
    }

    this.onSelectCategory(payload);
  }

  openConfirmationDialog(salesCode: any) {
    let title: string = 'Confirmation';
    let message: string =
      'Updating the item classification will also auto-update the Sales Code based on the new item classification. If a Sales Code was previously assigned to this item, it will be replaced with the new sales code. Are you sure you want to proceed?';
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-18 font-700',
        title: title,
        message: message,
        button: {
          success: { title: 'Proceed' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess }) => {
      if (isSuccess) {
        this.tire.salesCode = salesCode;
        //this.salesCodeOverideConfirm = true;
      }
      onClose.unsubscribe();
    });
  }

  logPXGaingSightCustomEvent(res: any) {
    if (res?.salesCode?.salesCodeId && res?.salesCode?.salesCodeId !== this.defaultSalesCode?.salesCodeId) {
      const logInfo = {
        itemName: res?.title || res?.name,
        salesCodeName: res?.salesCode?.title,
        salesCode: res?.salesCode?.shortName,
        category: res?.category?.name,
        subCategory: res?.category?.subCategoryName,
        itemType: res?.type,
        assignmentType: this.isAutoAssign ? 'Auto' : 'User has assigned sales code directly from the Catalog/RO',
      };
      this.helperService.logPXGaingSightEvent('Sales code assigned to an item', logInfo);
    }
  }

  onSelectCategory(event: any) {
    const { category, salesCode, isAutoAssign } = this.helperService.onCategorySelect(event, this.tire.salesCode?.salesCodeId);

    this.tire.category = category;
    if (this.tire.salesCode?.salesCodeId && salesCode?.salesCodeId !== this.tire?.salesCode?.salesCodeId) {
      this.openConfirmationDialog(salesCode);
    } else {
      this.tire.salesCode = salesCode;
    }

    this.isAutoAssign = isAutoAssign;

    this.subCategoriesSuggestions = [];
    this.subCategoriesSuggestionsResults = [];
    this.subSubCategoriesSuggestions = [];
    this.subSubCategoriesSuggestionsResults = [];
  }

  getAllCategories() {
    const query: any = { itemType: 'tire' };
    this.loader.category = true;
    // if (this.query) query.searchTerm = encodeURI(this.query);
    this.httpService
      .getPricingCategories(query)
      .then((res: any) => {
        this.categoriesSuggestions = res.categories;
        this.categoriesSuggestionsResults = this.helperService.deepCopy(this.categoriesSuggestions);
      })
      .finally(() => {
        this.loader.category = false;
        this.setPoDetailCategory();
        this.setServiceItemCategory();
      });
  }

  getSubCategories(item) {
    this.loader.subCategory = true;
    this.httpService
      .getPricingSubCategories(item.categoryId, 'tire')
      .then((res: any) => {
        if (res && res.subCategories?.length) {
          this.subCategoriesSuggestions = res.subCategories;
          this.subCategoriesSuggestionsResults = this.helperService.deepCopy(this.subCategoriesSuggestions);
        } else {
          this.subCategoriesSuggestions = [];
          this.subCategoriesSuggestionsResults = [];
        }
      })
      .finally(() => {
        this.loader.subCategory = false;
      });
  }

  getSubSubCategories(item, level2) {
    this.loader.subSubCategory = true;
    this.httpService
      .getPricingSubSubCategories(item.categoryId, level2.subCategoryId, 'tire')
      .then((res: any = {}) => {
        if (res && res.subSubCategories?.length) {
          this.subSubCategoriesSuggestions = res.subSubCategories;
          this.subSubCategoriesSuggestionsResults = this.helperService.deepCopy(this.subSubCategoriesSuggestions);
        } else {
          this.subSubCategoriesSuggestions = [];
          this.subSubCategoriesSuggestionsResults = [];
        }
      })
      .finally(() => {
        this.loader.subSubCategory = false;
      });
  }

  onTabSelect(event) {
    this.selectedTab = event?.index;
    if (this.selectedTab === 1) {
      this.getLogs();
    }
  }
}
